import { MailOutlined, MessageOutlined, WhatsAppOutlined } from '@ant-design/icons'
import { Button, Space, Typography } from 'antd'
import React, { useState, useEffect, useCallback } from 'react'
import { useIntl } from 'react-intl'

const { Text } = Typography

// Fungsi untuk menghitung waktu timer berdasarkan resendCount
const getTimerDuration = (resendCount) => {
  if (resendCount < 5) {
    return 60 // 1 menit
  }
  if (resendCount < 10) {
    return 120 // 2 menit
  }
  if (resendCount < 20) {
    return 240 // 4 menit
  }
  if (resendCount < 30) {
    return 480 // 8 menit
  }
  if (resendCount < 40) {
    return 960 // 16 menit
  }
  if (resendCount < 50) {
    return 1920 // 32 menit
  }
  return 3840 // 64 menit (jika >= 50)
}

const CHANNELS = [
  { key: 'email', label: 'Email', icon: <MailOutlined /> },
  { key: 'wa', label: 'WhatsApp', icon: <WhatsAppOutlined /> },
  { key: 'sms', label: 'SMS', icon: <MessageOutlined /> },
]

const ResendOTP = ({
  onResend,
  hideDescription = false,
  canResendWithChannel = false,
  loading,
}) => {
  const { formatMessage } = useIntl()
  const [countdown, setCountdown] = useState(60) // Default 1 menit
  const [resendCount, setResendCount] = useState(0)
  const [selectedChannel, setSelectedChannel] = useState('')

  // Update countdown ketika resendCount berubah
  useEffect(() => {
    const newDuration = getTimerDuration(resendCount)
    setCountdown(newDuration)
  }, [resendCount])

  useEffect(() => {
    let timer
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prevCount) => prevCount - 1)
      }, 1000)
    }
    return () => {
      if (timer) {
        clearInterval(timer)
      }
    }
  }, [countdown])

  const handleResend = useCallback(() => {
    onResend({
      callback: () => {
        if (canResendWithChannel) {
          setResendCount((prevCount) => prevCount + 1)
        } else {
          // Untuk kasus tanpa channel, tetap gunakan 1 menit
          setCountdown(60)
        }
      },
    })
  }, [canResendWithChannel, onResend])

  const handleResendWithChannel = useCallback(
    (channel) => {
      setSelectedChannel(channel)
      onResend({
        via: channel,
        callback: () => {
          setResendCount((prevCount) => prevCount + 1)
          // Timer akan diupdate otomatis oleh useEffect di atas
        },
      })
    },
    [onResend],
  )

  return (
    <Space>
      {!hideDescription && <Text>{formatMessage({ id: 'not_received_otp_code' })}</Text>}
      {canResendWithChannel ? (
        <Space direction="vertical" style={{ marginTop: 8, width: '100%' }}>
          <div style={{ textAlign: 'center' }}>
            <Text type="secondary">
              {`${formatMessage({ id: 'resend_code_by' })} ${
                countdown > 0 ? formatMessage({ id: 'in_second_value' }, { value: countdown }) : ''
              }`}
            </Text>
          </div>
          <div style={{ textAlign: 'center' }}>
            <Space>
              {CHANNELS.map((channel) => (
                <Button
                  key={channel.key}
                  onClick={() => handleResendWithChannel(channel.key)}
                  loading={selectedChannel === channel.key && loading}
                  disabled={countdown > 0 || loading}
                  icon={channel.icon}
                >
                  {channel.label}
                </Button>
              ))}
            </Space>
          </div>
        </Space>
      ) : (
        <Button
          size="small"
          type="link"
          onClick={handleResend}
          loading={loading}
          disabled={countdown > 0 || loading}
        >
          {countdown > 0
            ? `${formatMessage({ id: 'resend_code' })} (${countdown}s)`
            : formatMessage({ id: 'resend_code' })}
        </Button>
      )}
    </Space>
  )
}

export default ResendOTP
